<script>
import { groceryComputed, groceryMethods } from '@state/helpers';
import SearchInput from '@components/search-input/search-input.vue';

export default {
  components: {
    SearchInput,
  },
  props: {},
  data() {
    return {
      groceryOpts: ['All Groceries'],
      searchComponentKey: 0,
    };
  },
  computed: {
    ...groceryComputed,
  },
  mounted() {
    this.container = this.$el;
    this.container.scrollTop = this.lastScrollTop;
  },
  destroyed() {
    this.searchComponentKey++;
  },
  methods: {
    ...groceryMethods,
    onSelectItem(item) {
      this.setSelectedItem(item);
      this.groceryListComponent = 'BaseGroceryListDetail';
    },
    startShopping() {
      // TODO: Handle shopping...
    },
  },
};
</script>

<template>
  <div
    :class="[
      'grocery-list',
      { itemSelected: selectedItem, visible: isListActive },
    ]"
  >
    <div class="grocery-list-header">
      <div class="grocery-list-actions">
        <SearchInput :key="searchComponentKey" />
        <div class="grocery-list-subheader">
          <BaseButton
            type="button"
            class="btn-primary btn-round btn-ghost"
            @click="startShopping"
          >
            Start Shopping
          </BaseButton>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label>Filter</label>
          <v-select
            :options="groceryOpts"
            :searchable="false"
            :clearable="false"
          />
        </div>
      </div>
    </div>

    <BaseGroceryListItem
      v-for="item in groceryList"
      :key="item._id"
      :item="item"
      :isCategory="true"
      @select-item="onSelectItem"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.grocery-list {
  height: 100%;

  .grocery-list-subheader button {
    margin: 1rem 0 2rem;
    padding: 1rem 1.2rem;
  }

  .grocery-list-header {
    margin: 1rem 0 2.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    .grocery-list-actions {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }
  }

  &.itemSelected {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }
}
</style>
